import styles from "./About.module.css";
const About = () => {
  return (
    <div className={styles.mainContain}>
      <div className={styles.left_panel}>
        <h1>About</h1>
          <p>Hello! Like it says on the login page, I created this website so that
              my friends and I can keep track of all the movies we wanted to watch.
              Sure there are already other ways of doing that, but I didn't make those.
          </p>
          <p>This website is a work in progress so please bare with me as it goes through
             the motions. If you encounter any bugs please don't hesitate to
              reach out to me shpoopdy@gmail.com. 
          </p>
          <p>The site will get better...maybe 🤓</p>
      </div>
    </div>
  )
}

export default About;